<!--
  @负责人: xiehan
  @创建时间: 2019-02-19
  @版本:v2.0.2
  @描述: 流程管理-模板管理
-->

<template>
  <div class="handlerWorkFlowTemplate">
    <g-back :history="history"></g-back>
    <div class="btn-position">
      <el-button
        @click="backToList"
        v-text="$t('common.cancel')"></el-button>
      <el-button type="primary" 
        v-g-rac="gRac('handlerWorkFlowTemplate@save')"
        @click="saveTemplate"
        v-text="$t('common.save')"></el-button>
    </div>
    <el-card class="box-card">
      <div slot="header">
        <div class="template-title">
          <el-form ref="titleForm" :model="titleForm" label-width="330px">
            <el-form-item 
              prop="title"
              :label="$t('workFlowTemplateManage.templateTitle')"
              :rules="[{ required: true, message: $t('common.entryTips') + $t('workFlowTemplateManage.templateTitle') }]">
              <el-input v-model="titleForm.title"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div>
        <el-form ref="templateForm" label-position="left">
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.applicant')" label-width="50px">
              <span>xxx</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.department')" label-width="80px">
              <span>xxx</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.time')" label-width="70px">
              <span>xxx</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.siteType')" label-width="40px">
              <span>xxx</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.approver')" label-width="50px">
              <span>xxx</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.operator')" label-width="50px">
              <span>xxx</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.ccpeople')" label-width="70px">
              <span>xxx</span>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <i class="separation-line"></i>
      <div>
        <el-button type="primary"
          class="mb-base"
          @click="addProperty"
          v-text="$t('workFlowTemplateManage.addProperty')"></el-button>
        <el-table
          :data="propertyTable"
          border
          style="width: 100%">
          <el-table-column prop="property" :label="$t('workFlowTemplateManage.property')"></el-table-column>
          <el-table-column prop="name" :label="$t('workFlowTemplateManage.name')"></el-table-column>
          <el-table-column prop="type" :label="$t('workFlowTemplateManage.type')"></el-table-column>
          <el-table-column prop="value" :label="$t('workFlowTemplateManage.value')"></el-table-column>
          <el-table-column prop="require" :label="$t('workFlowTemplateManage.require')"></el-table-column>
          <el-table-column :label="$t('common.handle')">
            <template slot-scope="scope">
              <el-button type="text" size="small" v-text="$t('common.edit')" @click="editProperty(scope)"></el-button>
              <el-button type="text" size="small" v-text="$t('common.delete')" @click="deleteProperty(scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <i class="separation-line"></i>
      <el-form ref="templateFormReason" input-width="auto" label-width="80px">
        <el-form-item :label="$t('cloudApplication.reason')">
          <span>xxx</span>
        </el-form-item>
        <el-form-item :label="$t('cloudApplication.remark')">
          <span>xxx</span>
        </el-form-item>
        <el-form-item :label="$t('cloudApplication.option')">
          <span v-text="$t('common.agree')"></span>
        </el-form-item>
        <el-form-item>
          <span>xxx</span>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog :closeOnClickModal="false"
      :title="choosenIndex === -1 ? $t('workFlowTemplateManage.addProperty') : $t('workFlowTemplateManage.editProperty')"
      :visible.sync="propertyVis"
      width="400px">
      <el-form label-width="80px" :model="propertyForm" ref="propertyForm">
        <el-form-item :label="$t('workFlowTemplateManage.property')"
          prop="property"
          :rules="[{ required: true, message: $t('common.entryTips') + $t('workFlowTemplateManage.property') }]">
          <el-input v-model="propertyForm.property"></el-input>
        </el-form-item>
        <el-form-item :label="$t('workFlowTemplateManage.name')"
          prop="name"
          :rules="[{ required: true, message: $t('common.entryTips') + $t('workFlowTemplateManage.name') }]">
          <el-input v-model="propertyForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('workFlowTemplateManage.type')">
          <g-select v-model="propertyForm.type" :list="select_type"></g-select>
        </el-form-item>
        <el-form-item :label="$t('workFlowTemplateManage.value')">
          <el-input v-model="propertyForm.value"></el-input>
        </el-form-item>
        <el-form-item :label="$t('workFlowTemplateManage.require')">
          <el-checkbox v-model="propertyForm.require"></el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="propertyVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" v-text="$t('common.confirm')" @click="confirmAddProperty"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import workFlowTemplateManageBiz from '@/logic/workFlow/workFlowTemplateManageBiz'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        history: [],
        titleForm: {
          title: ''
        },
        propertyTable: [],
        propertyVis: false,
        propertyForm: {
          property: '',
          name: '',
          type: '',
          value: '',
          require: false
        },
        select_type: {},
        choosenIndex: -1,
        type: ''
      }
    },
    methods: {
      async preInitDic () {
        await Promise.all([
          this.dGetDictionaryByCode('vauleType')
        ])
        this.select_type = { ...this.dDictionary.vauleType }
        this.propertyForm.type = Object.keys(this.select_type)[0]
        this.propertyTable = []
        if (this.$route.query.id) {
          workFlowTemplateManageBiz.findTemplateById({ id: this.$route.query.id }).then(res => {
            this.titleForm.title = res.name
            this.setHistory(res.name)
            this.type = res.type
            res.propertyList.map(item => {
              this.propertyTable.push({
                property: item.property,
                name: item.name,
                type: this.select_type[item.type],
                value: item.value,
                require: item.require ? this.$t('workFlowTemplateManage.yes') : this.$t('workFlowTemplateManage.no')
              })
            })
          })
        } else {
          this.setHistory()
        }
      },
      setHistory (name) {
        this.history = []
        this.history.push({ name: name || this.$t('workFlowTemplateManage.addTemplate') })
      },
      backToList () {
        this.$router.push({ name: 'workFlowTemplateManage' })
      },
      saveTemplate () {
        this.$refs['titleForm'].validate((valid) => {
          if (valid) {
            this.propertyTable.map(item => {
              item.type = Object.keys(this.select_type).filter(_item => this.select_type[_item] === item.type)[0]
              item.require = item.require === this.$t('workFlowTemplateManage.yes')
            })
            let saveObj = this.$route.query.id ? {
              id: this.$route.query.id,
              name: this.titleForm.title,
              propertyList: this.propertyTable,
              type: this.type
            } : {
              name: this.titleForm.title,
              propertyList: this.propertyTable,
              type: this.$route.query.type
            }
            let eventName = this.$route.query.id ? 'updateTemplate' : 'saveTemplate'
            workFlowTemplateManageBiz[eventName]({ ...saveObj }).then((res) => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'workFlowTemplateManage' })
            })
          } else {
            return false
          }
        })
      },
      addProperty () {
        this.choosenIndex = -1
        this.propertyForm = {
          property: '',
          name: '',
          type: Object.keys(this.select_type)[0],
          value: '',
          require: false
        }
        this.propertyVis = true
        this.$nextTick(() => {
          this.$refs['propertyForm'].clearValidate()
        })
      },
      editProperty (info) {
        this.choosenIndex = info.$index
        this.propertyForm.property = info.row.property
        this.propertyForm.name = info.row.name
        this.propertyForm.type = Object.keys(this.select_type).filter(item => this.select_type[item] === info.row.type)[0]
        this.propertyForm.value = info.row.value
        this.propertyForm.require = info.row.require === this.$t('workFlowTemplateManage.yes')
        this.propertyVis = true
      },
      deleteProperty (index) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          this.propertyTable.splice(index, 1)
        }).catch(() => {})
      },
      confirmAddProperty () {
        this.$refs['propertyForm'].validate((valid) => {
          if (valid) {
            if (this.choosenIndex === -1) {
              this.propertyTable.push({
                property: this.propertyForm.property,
                name: this.propertyForm.name,
                type: this.select_type[this.propertyForm.type],
                value: this.propertyForm.value,
                require: this.propertyForm.require ? this.$t('workFlowTemplateManage.yes') : this.$t('workFlowTemplateManage.no')
              })
            } else {
              this.propertyTable.splice(this.choosenIndex, 1, {
                property: this.propertyForm.property,
                name: this.propertyForm.name,
                type: this.select_type[this.propertyForm.type],
                value: this.propertyForm.value,
                require: this.propertyForm.require ? this.$t('workFlowTemplateManage.yes') : this.$t('workFlowTemplateManage.no')
              })
            }
            this.propertyVis = false
          } else {
            return false
          }
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'handlerWorkFlowTemplate' && from.name === 'workFlowTemplateManage') {
          this.titleForm.title = ''
          this.preInitDic()
          this.$nextTick(() => {
            this.$refs['titleForm'].clearValidate()
          })
        }
      }
    },
    mounted () {
      this.preInitDic()
    }
  }
</script>

<style scoped>
  .btn-position {
    width: 800px;
    text-align: center;
    margin-bottom: 10px;
  }
  .template-title {
    margin-top: 16px;
  }
  .el-form {
    overflow: hidden;
  }
  .box-card {
    width: 800px;
  }
  .separation-line {
    display: block;
    height: 1px;
    background: #eee;
    margin: 20px 0;
  }
</style>